import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'Antes tardaba 45 minutos en redactar un informe de CUD. Con las plantillas lo resuelvo en 5. Ya solo por eso valió la pena.',
    author: 'Dr. Martín R.',
    role: 'Neurólogo Infantil',
    location: 'Buenos Aires'
  }, {
    quote: 'El sistema de screening in-situ cambió mi forma de trabajar. Ahora tengo evidencia observable en la misma consulta para justificar la medicación o la derivación.',
    author: 'Dra. Carolina S.',
    role: 'Psiquiatra Infantil',
    location: 'Córdoba'
  }, {
    quote: 'Las guías para padres son increíbles. Los entrego al dar el diagnóstico y los mensajes de WhatsApp bajaron un 70%. No exagero.',
    author: 'Dr. Sebastián M.',
    role: 'Neurólogo',
    location: 'Rosario'
  }, {
    quote: 'El bono de retención clínica fue lo que más me impactó. Ahora las familias llegan con el tracker completo y la consulta de seguimiento dura la mitad.',
    author: 'Dra. Florencia G.',
    role: 'Psiquiatra',
    location: 'Mendoza'
  }, {
    quote: 'El módulo de deterioro cognitivo y las planillas de seguimiento me ahorran horas de explicaciones. Excelente inversión para el consultorio.',
    author: 'Dr. Nicolás F.',
    role: 'Psiquiatra de Adultos',
    location: 'La Plata'
  }];
  return <section className="py-20 bg-[#111827] border-y border-gray-800/50" data-id="element-261">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-262">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-263">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-264">
            LO QUE DICEN LOS COLEGAS
          </h2>
          <p className="text-xl text-gray-400" data-id="element-265">
            Neurólogos y Psiquiatras que ya usan el Mega Kit Neuro-Pro en su
            consultorio:
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-266">
          {testimonials.map((test, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="bg-[#1a2332] border border-gray-800 rounded-2xl p-6 flex flex-col" data-id="element-267">
              <div className="flex gap-1 mb-4" data-id="element-268">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-yellow-500 text-yellow-500" data-id="element-269" />)}
              </div>
              <p className="text-gray-300 italic mb-6 flex-grow" data-id="element-270">
                "{test.quote}"
              </p>
              <div className="border-t border-gray-800 pt-4" data-id="element-271">
                <p className="font-bold text-white" data-id="element-272">{test.author}</p>
                <p className="text-sm text-yellow-500" data-id="element-273">
                  {test.role} | {test.location}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}